<template>
  <div id="CompanySidebar">
      <slot name="subadmin-select"></slot>
      
      <el-menu
      ref='abc'
      router
      :default-active="$route.path"
      :unique-opened="true"
      class="el-menu-vertical-demo"
      @open="menuopen">
      <!-- 一级菜单 -->
      <template v-for="item in companyMenuList">
        <el-submenu v-if="item.children && item.children.length" :index="item.url+''" :key="item.url" >
          <template slot="title"><i :class="item.menuIcon" style="color:#333333;padding-right:10px"></i><span>{{item.name}}</span></template>
          
          <!-- 二级菜单 -->
          <template v-for="itemChild in item.children">
            <el-submenu v-if="itemChild.children && itemChild.children.length" :index="itemChild.url+''" :key="itemChild.url" >
                <template slot="title"><i :class="itemChild.menuIcon" style="color:#333333;padding-right:10px"></i>
                  
                  <el-tooltip :content="itemChild.name" placement="top" v-if="itemChild.name.length>8">
                    <span   style="display:inline-block;width:120px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;">{{itemChild.name}}</span>
                  </el-tooltip>  

                  <span v-else style="">{{itemChild.name}}</span>
                
                </template>
                
                <!-- 三级菜单 -->
                <el-menu-item v-for="itemChild_Child in itemChild.children" :index="itemChild_Child.url+''" :key="itemChild_Child.url">
                  <i :class="itemChild_Child.menuIcon" style="color:#333333;padding-right:10px"></i>
                  <el-tooltip :content="itemChild_Child.name" placement="top" v-if="itemChild_Child.name.length>8">
                    <span   style="display:inline-block;width:130px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;">{{itemChild_Child.name}}</span>
                  </el-tooltip>
                  <span  v-else style="">{{itemChild_Child.name}}</span>
                  <!-- <span  slot="title" style="display:inline-block;width:130px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;">{{itemChild_Child.name}}</span> -->
                </el-menu-item>
            </el-submenu>
            
            <el-menu-item v-else :index="itemChild.url" :key="itemChild.url" :id="menuIndexId(itemChild)"><i :class="itemChild.icon"></i><span slot="title">{{itemChild.name}}</span></el-menu-item>
          </template>
        </el-submenu>
        
        <el-menu-item v-else :index="item.url+''" :key="item.url">
          <i :class="item.menuIcon" :style="computeIconstyle(item)"></i>
          <span slot="title">{{item.name}}</span>
        </el-menu-item>
      </template>
    </el-menu>

  </div>
</template>

<script>
import {EnterpriseUserIndex,GetNotificationsRecordApi,CreateNotificationsRecordApi,NotifyAuditPassedApi} from '@/js/enterPriseApi.js'
import Driver from 'driver.js' // import driver.js
import 'driver.js/dist/driver.min.css' // import driver.js css
import {GetMenuListApi} from '@/js/Api/PermissionApi.js'
import Bus from '@/js/bus'
import {stepsAlloCation,stepsPermissionManage} from '@/js/userSteps/userstep.js'
export default {
  name: 'CompanySidebar',
  data() {
    return {
        certificatationStatus:'',
        showSider:false,
        defaultActive: "",
        router:'',
        allocationGuideFlag:false,
        permissionGuideFlag:false,
        companyMenuList:[],
        driver:null,
    };
  },
  computed: {
    computeIconstyle(){
      return function(item){
        return {
          color:this.$route.path===item.url?'#0069e0':'#333',
          paddingRight:'6px'
        }
      }
    }
  },
  created() {
    this.getCompanyInfo();
    this.GetMenuList();
    this.getNoticationRecord();
  },
  methods: {
      send(){
        //Bus.$emit('updateStartSignalR','delete')
        NotifyAuditPassedApi({
          message:'123'
        })
        .then(res=>{
          console.log(res)
        })
        .catch(err=>{
          console.log(err)
        })
      },
      updatemySideBar(){//重新认证时 更新菜单
          this.GetMenuList();
      },
      changeMenuByCurrentRole(){
        
        this.checkMenuPath(this.companyMenuList[0])
      },
      checkMenuPath(menuList){//跳转该菜单的路由
        if(menuList.children.length){
            let menuChildren=menuList.children[0]
            this.checkMenuPath(menuChildren)
        }else{
            this.$router.push(menuList.url)
        }
       },
      getNoticationRecord(){//获取用户引导通知
          let that=this
            GetNotificationsRecordApi({
                recordType:0
            })
            .then(res=>{
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    let AllocationArr=data.filter(item=>{
                      return item.recordType===3
                    })
                    let permissionArr=data.filter(item=>{
                      return item.recordType===2
                    })
                    if(AllocationArr.length==0){
                      this.allocationGuideFlag=true
                    }
                    if(permissionArr.length==0){
                       this.permissionGuideFlag=true
                    } 
                    
                }else{
                    that.memberloading=false;
                    this.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
          })
      },

       menuIndexId(ele){//为二级菜单动态添加ID，做功能引导用
          if(ele.name==='部门授权分拨' && ele.url==='/depEmpowerAllocation'){
            return 'depEmpowerAllocation'
          }else if(ele.name==='权限管理' && ele.url==='/adminpermissionManage'){
            return 'adminpermissionManage'
          }
       },
       menuopen(index,indexpath){
          if(index==='/superadmin-power'){//授权分拨菜单展开,该菜单为后台配置的
                if(this.allocationGuideFlag){
                    this.$nextTick(()=>{
                      setTimeout(()=>{
                        this.guideAllocate()
                      },1000)
                  }) 
                }
                
          }else if(index==='/superadmin-manage'){//权限管理菜单的展开,该菜单为后台配置的
            if(this.permissionGuideFlag){
                this.$nextTick(()=>{
                  setTimeout(()=>{
                          this.guidePermission()
                  },1000)
              }) 
            }
          }
       },
       guideAllocate(callbacks){//授权分拨
            this.driver = new Driver({
                animate:false,
                doneBtnText: "知道了", // 结束按钮的文字
                allowClose: false, // 是否可以通过点击遮罩层关闭指引
                stageBackground: "#fff", // 突出显示元素的背景颜色
                nextBtnText: "下一步", // 下一步按钮的文字
                prevBtnText: "上一步", // 上一步按钮的文字
                closeBtnText: "关闭", // 关闭按钮的文字
                keyboardControl: false, // 是否允许键盘操控
                xCloseButton: true, // 将关闭按钮作为X放在弹出
                onReset: ele => {
                    this.handleClicknotice(3)//传入recordType
                }, // 关闭 跳过
            })
            const t=1
            this.driver.defineSteps(stepsAlloCation(t))
            this.driver.start()
            this.$nextTick(()=>{
                window.clickFun = this.clickFunAllocate;
            })
        },
        clickFunAllocate(){//分拨授权详情按钮点击
            window.open('http://doc.pkpm.cn/docs/glyzh_wb/glyzh_wb-1ebhh5a2ncedc','_blank')
        },
        handleClicknotice(recordType){//跳过之后调用接口之后不在弹出
            let that=this
            console.log(recordType)
            CreateNotificationsRecordApi({
                recordType:recordType
            })
            .then(res=>{
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    if(recordType===3){//关闭提示，不再弹出
                      this.allocationGuideFlag=false
                    }else if(recordType===2){//关闭提示，不再弹出
                      this.permissionGuideFlag=false
                    }
                }else{
                    this.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })
        },
        guidePermission(){//权限管理引导
            this.driver = new Driver({
                animate:false,
                doneBtnText: "知道了", // 结束按钮的文字
                allowClose: false, // 是否可以通过点击遮罩层关闭指引
                stageBackground: "#fff", // 突出显示元素的背景颜色
                nextBtnText: "下一步", // 下一步按钮的文字
                prevBtnText: "上一步", // 上一步按钮的文字
                closeBtnText: "关闭", // 关闭按钮的文字
                keyboardControl: false, // 是否允许键盘操控
                xCloseButton: true, // 将关闭按钮作为X放在弹出
                onReset: ele => {
                    this.handleClicknotice(2)//传入recordType
                }, // 关闭 跳过
            })
            const t=1
            this.driver.defineSteps(stepsPermissionManage(t))
            this.driver.start()
            this.$nextTick(()=>{
                window.clickFun = this.clickFunPermission;
            })
        },
        clickFunPermission(){//权限管理详情按钮点击
          console.log('222')
          window.open('http://doc.pkpm.cn/docs/glyzh_wb/glyzh_wb-1ebh1nt6ds3uc','_blank')
        },
        GetMenuList(){
          let that=this;
          GetMenuListApi()
          .then(res=>{
            if(res.status===200 && res.data.error_code===0){
                const {data} =res.data
                //菜单判断，判断有没有消息通知的菜单
                this.$emit('menuReady',data)
                this.companyMenuList=this.toTreeData(data)
            }else{
              that.$message.error(res.data.error_msg)
            }
          })
          .catch(err=>{
            console.log(err)
            if(err.data && err.data.errorMessages){
                that.$message.error(err.data.errorMessages[0]);
            }else if(err.data){
                that.$message.error(err.data)
            }
          })
        },
        toTreeData(data, attr) {//将父子关系的数组转化为树结构
          let tree = []
          let sortArr=data.sort(this.compare('sortNum'));
          sortArr.map(item =>{
              if(Object.prototype.hasOwnProperty.call(item, 'parentId') && item.parentId==null ||item.parentId==''){//是否含有pid，如果没有则是第一层
                  let obj=Object.assign({},item)
                  obj.children=[]
                  tree.push(obj)//把最外层父级push进去
              }
          })
          let res=this.childerData(tree,sortArr)
          return res
      },
      childerData(tree,data){
        for(let i=0;i<tree.length;i++){//循环树形父级元素
            for(let j = 0;j<data.length;j++){//循环数据
            //判断数据的pid是不是等于父级的id，如果是则代表是当前父级的子级
                if(tree[i].menuId == data[j].parentId){
                    let obj=Object.assign({},data[j])
                    obj.children=[]
                    tree[i].children.push(obj)//加入到父级的子级数组中
                }
            }
            this.childerData(tree[i].children,data)//递归调用自己，传入第二层元素 
        }
        return tree
      },
      compare(property){//排序函数,从小到大。
        return function(a,b){
            var value1 = a[property];
            var value2 = b[property];
            return value1 - value2;
        }
      },
       getCompanyInfo(){//获取企业主页信息
            let that=this;
            let params=window.localStorage.getItem('enterPriseId');
            EnterpriseUserIndex(params)
            .then(res=>{
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    that.$store.commit("setCurrentVerifystatus",data.certificatationStatus);
                }else{
                    this.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }
            })
        },
 },
}
</script>


<style lang="scss" >
#CompanySidebar {
  width: 100%;
  height: 100%;
  text-align: left;
  padding: 10px 10px 0px 10px;
  .sidebarimg{
    width: 16px;
    margin-right: 8px;
  }
  .el-menu {
    border: 0;
  }
  .el-menu-item.is-active {
    color: #0069e0;
    font-weight: 700;
    background: #f2f7ff;
  }
  /deep/ .el-menu-item{
    padding-left: 14px !important;
  }
  .el-submenu .el-menu-item {
    padding-left: 55px !important;
    min-width: auto !important;
    height: 40px;
    line-height: 40px !important;
  }
  /deep/ .el-submenu__title{
    color: #181818;
    padding-left: 14px !important;
    padding-right: 14px !important;
    i{
      color: #181818;
      font-weight: 700;
    }
  }
}
</style>
<style lang="scss">
    .button-popper{
      width: 70px !important;
      min-width:70px !important;
      max-width:70px !important;
      padding: 2px 0 !important;
      .ulstyle{
          text-align: center;
          li{
              padding: 3px 0;
              cursor: pointer;
          }
          li:hover{
              background:#ecf5ff;
              color:#66b1ff;
          }
      }
  }
    #driver-popover-item{
        width: 800px !important;
        max-width: 800px !important;
    }
</style>


// WEBPACK FOOTER //
// src/view/CompanyUser/CompanySideBar.vue